 

const config = 
{
 speech:{
    region: "eastus2",
    key: "87036521843b4f32a0122f8ac99b74b7",
    endpoint: "https://eastus2.api.cognitive.microsoft.com/sts/v1.0/issuetoken"
  },
}

export default config;